import React from 'react';
import { observer } from 'mobx-react';

import { ScreenStore } from '../../../stores/ScreenStore';
import { CompareStore } from '../../../stores/CompareStore';
import { constants } from '../../../config';
import { WindowHelper } from '../../../helpers/WindowHelper';
import { CharacteristicsSection } from '../characteristics-section';
import { FAQSection } from '../faq-section';
import { FinancingSection } from '../financing-section';
import { ImageCarousel } from '../image-carousel';
import { MakeQuestionSection } from '../make-question-section';
import { OtherProductsSection } from '../other-products-section';
import { ProductDescriptor } from '../product-descriptor';
import { ProductStore } from '../stores/ProductStore';
import { Separator } from '../separator';
import { TopBodyMobile } from '../top-body-mobile';
import { VideosSection } from '../videos-section';
import styles from './MainBody.css';
import { SEO } from '../../../common/seo/Seo';

const SCROLL_TOP_OFFSET = 70;

const MainBody = observer(class MainBody extends React.Component {
  constructor(props) {
    super(props);
    this._faqRef = null;
    this._financingRef = null;
    this._scrollToFinancing = this._scrollToFinancing.bind(this);
    this._scrollToFAQ = this._scrollToFAQ.bind(this);
    this._updateFAQRef = this._updateFAQRef.bind(this);
    this._updateFinancingRef = this._updateFinancingRef.bind(this);
  }

  _updateFinancingRef(element = null) {
    this._financingRef = element;
  }

  _scrollToFinancing() {
    if (this._financingRef) {
      WindowHelper.scrollTo({
        left: 0,
        top: this._financingRef.offsetTop - SCROLL_TOP_OFFSET,
        behavior: 'smooth',
      });
    }
  }

  _updateFAQRef(element = null) {
    this._faqRef = element;
  }

  _scrollToFAQ() {
    WindowHelper.scrollTo({
      left: 0,
      top: this._faqRef.offsetTop - SCROLL_TOP_OFFSET,
      behavior: 'smooth',
    });
  }

  render() {
    if (!ProductStore.product) {
      return null;
    }
    const showMobileVersion = ScreenStore.screenWidth <= constants.breakpoints.smallMaxWidth;
    const { product } = ProductStore;
    const { products } = CompareStore;

    const withComparison = products.length ? styles.withComparison : '';

    return (
      <div className={styles.container}>
        <SEO
          title={`Producto ${ProductStore.product.name && ProductStore.product.name.trim()}`}
          description={`Descubre el ${ProductStore.product.name && ProductStore.product.name.trim()} en Carlos Gutiérrez S.A,
            diseñado para ofrecerte la mejor calidad y rendimiento. Explora sus detalles, especificaciones
            y opciones disponibles para tomar la mejor decisión de compra. Además,
            disfruta de precios competitivos, envío rápido y atención al cliente excepcional.
            ¡Haz tu pedido hoy y lleva a casa el ${ProductStore.product.name && ProductStore.product.name.trim()} que transformará
            tu experiencia!`}
          type="product"
          image={ProductStore.product.images.length > 0 && `${ProductStore.product.images[0]}-mobile-1x.jpg`}
          keyword={ProductStore.product.name && ProductStore.product.name.trim()}
        />
        {
          !showMobileVersion &&
          <div className={styles.productDescriptorContainer}>
            <div className={styles.productDescriptorWrapper}>
              <div className={styles.productDescriptorAbsoluteContainer}>
                <ProductDescriptor
                  className={styles.productDescriptor}
                  onSeeAllFinancingPlans={this._scrollToFinancing}
                  onScrollToFAQ={this._scrollToFAQ}
                />
              </div>
            </div>
          </div>
        }
        <div className={[withComparison, styles.mainContent].join(' ')}>
          {
            showMobileVersion &&
            <TopBodyMobile />
          }
          {
            !showMobileVersion &&
            <div>
              <ImageCarousel className={styles.imageCarousel} />
              <Separator />
              <CharacteristicsSection
                characteristics={product.characteristics}
              />
            </div>
          }
          {
            (product.ableToSell || product.stockIsEmpty()) &&
            <div className={styles.extraSmallContainer}>
              <FinancingSection reference={this._updateFinancingRef} />
              <Separator />
            </div>
          }
          {
            showMobileVersion &&
            <div className={styles.extraSmallContainer}>
              <CharacteristicsSection
                characteristics={product.characteristics}
                mobileVersion
              />
              <Separator />
            </div>
          }
          <div className={styles.extraSmallContainer}>
            <OtherProductsSection />
            <VideosSection />
            <FAQSection reference={this._updateFAQRef} />
            <MakeQuestionSection />
          </div>
        </div>
      </div>
    );
  }
});

export { MainBody };




// WEBPACK FOOTER //
// ./src/pages/product-detail/main-body/MainBody.jsx